import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";
import { api } from "../lib/api";

export default function Signup() {
  const nav = useNavigate();
  const { setToken, refresh } = useAuth();
  const [sp] = useSearchParams();
  const refCode = sp.get("ref") || "";
  const giftSource = sp.get("utm_source") === "gift";
  const utm = {
    utm_source: sp.get("utm_source") || undefined,
    utm_medium: sp.get("utm_medium") || undefined,
    utm_campaign: sp.get("utm_campaign") || undefined,
    utm_content: sp.get("utm_content") || undefined,
    share_video_id: sp.get("share_video_id") || undefined,
  };
  const [name, setN] = useState("");
  const [email, setE] = useState(sp.get("email") || "");
  const [pw, setPw] = useState("");
  const [loading, setL] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setL(true);
    try {
      const { data } = await api.post("/auth/register", {
        name, email, password: pw,
        referral_code: refCode || undefined,
        ...utm,
      });
      setToken(data.token);
      await refresh();
      // A/B test conversion ping — fire-and-forget
      try {
        const pending = JSON.parse(localStorage.getItem("cc_ab_pending_signup") || "null");
        const variant = localStorage.getItem("cc_ab_variant");
        if (pending && variant) {
          api.post("/landing/track", {
            variant,
            event: "signup_completed",
            visitor_id: localStorage.getItem("cc_visitor_id") || "",
          }).catch(() => {});
          localStorage.removeItem("cc_ab_pending_signup");
        }
      } catch (_e) { /* ignore */ }
      if (giftSource) toast.success("Account created · Your gift is unlocked! 🎁");
      else if (refCode) toast.success("Account created · Friend referral applied!");
      else toast.success("Account created!");
      nav("/profiles");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Signup failed");
    } finally { setL(false); }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white relative">
      <img src="https://images.unsplash.com/photo-1759842952767-456f1b6dded8?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400" className="absolute inset-0 w-full h-full object-cover opacity-40" alt="" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/80 via-[#0A0A0A]/85 to-[#0A0A0A]" />
      <header className="relative z-10 px-6 lg:px-12 py-6">
        <Link to="/" className="text-[#E50914] font-black text-2xl">CINECINEMA</Link>
      </header>
      <main className="relative z-10 max-w-md mx-auto px-6 py-12">
        <div className="bg-black/70 backdrop-blur-xl rounded-lg p-10 border border-white/5 shadow-2xl">
          <h1 className="text-3xl font-bold mb-2">Create account</h1>
          <p className="text-gray-400 text-sm mb-6">Start your unlimited streaming in seconds.</p>
          {giftSource && (
            <div data-testid="gift-banner" className="mb-5 bg-gradient-to-r from-pink-900/40 to-[#1a0a14] border border-pink-500/40 rounded-md p-3 text-sm">
              🎁 <span className="font-semibold">A friend sent you a ticket.</span> Sign up with this email to auto-unlock it.
            </div>
          )}
          {refCode && (
            <div data-testid="ref-banner" className="mb-5 bg-gradient-to-r from-[#1a0808] to-[#0f0404] border border-[#E50914]/40 rounded-md p-3 text-sm">
              🎁 Friend referral: <span className="font-mono font-bold">{refCode}</span> — both you and your friend get a free month when you subscribe.
            </div>
          )}
          <form onSubmit={submit} className="space-y-4">
            <input data-testid="signup-name" required placeholder="Full name" className="input-dark" value={name} onChange={(e) => setN(e.target.value)} />
            <input data-testid="signup-email" type="email" required placeholder="Email address" className="input-dark" value={email} onChange={(e) => setE(e.target.value)} />
            <input data-testid="signup-password" type="password" minLength={6} required placeholder="Password (min 6 chars)" className="input-dark" value={pw} onChange={(e) => setPw(e.target.value)} />
            <button data-testid="signup-submit" disabled={loading} className="btn-red w-full py-3 rounded font-semibold mt-2">
              {loading ? "Creating..." : "Create Account"}
            </button>
          </form>
          <p className="mt-8 text-gray-400 text-sm">
            Already have an account? <Link to="/login" className="text-white hover:underline">Sign in.</Link>
          </p>
        </div>
      </main>
    </div>
  );
}
